import React from 'react'
import { usePage } from '@inertiajs/react'
import {
  Box, Typography, Paper,
} from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'
import AppShell from '../../components/layout/AppShell'
import PageHeader from '../../components/ui/PageHeader'

Placeholder.layout = (page) => <AppShell>{page}</AppShell>

export default function Placeholder({ title = 'Seite in Entwicklung', section }) {
  const { props } = usePage()
  const tenant = props.tenant || {}

  const hasPropertyContext = !!props.current_property
  const breadcrumbs = hasPropertyContext ? [] : [{ label: 'Dashboard', href: `/m/${tenant.slug}` }]
  if (section) breadcrumbs.push({ label: section })

  return (
    <Box>
      <PageHeader title={title} breadcrumbs={breadcrumbs} />
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
        }}
        data-testid="placeholder-page"
      >
        <ConstructionIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Diese Seite wird gerade entwickelt
        </Typography>
        <Typography variant="body2" color="text.disabled">
          Diese Funktion ist noch nicht verfügbar.
        </Typography>
      </Paper>
    </Box>
  )
}
